// extracted by mini-css-extract-plugin
export default {"formItemX":"GroupModal_formItemX__Y0lrk"};